// web/src/lib/api.js
import axios from "axios";

const isProd = process.env.NODE_ENV === "production";
const baseURL =
  process.env.REACT_APP_API_URL ||
  process.env.VITE_API_URL ||
  (isProd ? "/api" : "http://localhost:3001");

export const api = axios.create({
  baseURL,
  headers: { "Content-Type": "application/json" },
});

export const authApi = axios.create({
  baseURL,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});